export default "__VITE_ASSET__BnltNVuY__"